(function () {
  'use strict';
  const config = typeof document !== 'undefined' ? document.getElementById('edm-set-config') : null;
  const ALL_PRODUCTS = config?.dataset.scope === 'all-products';
  const OFFER = ALL_PRODUCTS ? config.dataset.offerId : 'coral-edm-20';
  const PRODUCT = '8734743756992';
  const VARIANT = '48994611232960';
  const matchesTarget = (item, all, offer) => (all ? item.properties?._gift !== 'true' && Number(item.final_price) > 0
    : String(item.variant_id || item.id) === VARIANT)
    && item.properties?._edm_offer === offer && typeof item.properties?._edm_ticket === 'string';
  const isTarget = item => matchesTarget(item, ALL_PRODUCTS, OFFER);
  const isGift = (item, status) => String(item.variant_id || item.id) === String(status?.giftVariantId)
    || ([OFFER, ...(ALL_PRODUCTS ? ['coral-edm-20'] : [])].includes(item.properties?._edm_offer) && item.properties?._gift === 'true');
  function cartPlan(cart, status) {
    const targets = cart.items.filter(item => matchesTarget(item, status?.scope === 'all-products' || ALL_PRODUCTS, status?.offer || OFFER));
    const gifts = cart.items.filter(item => isGift(item, status));
    const updates = {};
    const qualified = status?.state === 'available' && targets.some(item => item.properties._edm_ticket === status.ticket);
    let kept = false;
    for (const gift of gifts) {
      const valid = qualified && !kept && String(gift.variant_id || gift.id) === String(status.giftVariantId)
        && gift.properties?._edm_ticket === status.ticket && gift.properties?._edm_offer === (status.offer || OFFER)
        && gift.original_price === 0 && gift.final_price === 0;
      if (!valid) updates[gift.key] = 0;
      else { kept = true; if (gift.quantity !== 1) updates[gift.key] = 1; }
    }
    return { updates, addGift: qualified && !kept, hasGift: kept, targets, gifts };
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { cartPlan, isTarget, isGift }; return; }
  if (!config || window.FuumuuiEdmSetLaunch) return;
  window.FuumuuiEdmSetLaunch = true;
  const params = new URLSearchParams(location.search), key = params.get('edm_gift');
  const storageKey = 'fuumuui-edm:' + OFFER;
  let remembered = null;
  if (ALL_PRODUCTS) {
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if (saved?.offer === OFFER && typeof saved.ticket === 'string' && saved.expiresAt > Date.now()) remembered = saved;
      else localStorage.removeItem(storageKey);
    } catch (_) { /* 无存储权限仍可使用 EDM 原始链接 */ }
  }
  const entry = (ALL_PRODUCTS ? params.get('edm_campaign') === OFFER || !!remembered
    : config.dataset.productId === PRODUCT && /\/products\/coral-ye-chen-watercolor-brush-set\/?$/.test(location.pathname))
    && (!!remembered || /^[a-f0-9]{64}$/.test(key || ''));
  if (!entry && config.dataset.cartParticipant !== 'true') return;
  const root = (window.Shopify?.routes?.root || config.dataset.root || '/').replace(/\/?$/, '/');
  const text = JSON.parse(config.dataset.translations);
  const css = document.createElement('link'); css.rel = 'stylesheet'; css.href = config.dataset.css; document.head.append(css);
  let state = null, ticket = remembered?.ticket || null, cart = null, tail = Promise.resolve(), syncing = false, busy = false, errorMessage = '';
  let ignoreOwnEvent = false, paintScheduled = false, adding = false;
  let externalChanges = 0, externalVersion = 0, dirty = false;
  let overlappingChanges = false;
  let pendingCart = null, stateAt = 0, giftProduct = null, giftProductAt = 0, giftRequest = null;
  let checkingOut = false, needsVerification = config.dataset.cartParticipant === 'true';
  const checkoutGuards = new Map();
  const guarded = new Map();
  const cartWasParticipant = config.dataset.cartParticipant === 'true';
  const sectionList = () => [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ].filter(s => document.getElementById(s.id));
  function serial(task) { const next = tail.then(task, task); tail = next.catch(() => {}); return next; }
  async function request(path, body) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      const value = await response.json();
      if (!response.ok || value.status || value.errors) throw new Error('EDM_REQUEST_FAILED');
      return value;
    } finally { clearTimeout(timeout); }
  }
  function setText(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function setHidden(node, value) { if (node && node.hidden !== value) node.hidden = value; }
  function productForms() {
    return Array.from(document.querySelectorAll('product-form')).filter(node => {
      const form = node.querySelector('form[action*="/cart/add"]');
      return form && (ALL_PRODUCTS || String(new FormData(form).get('id')) === VARIANT);
    });
  }
  function guardAccelerated(node, active) {
    if (!node) return;
    if (active && !guarded.has(node)) {
      guarded.set(node, { style: node.getAttribute('style'), inert: node.inert, hidden: node.hidden });
      node.style.setProperty('display', 'none', 'important'); node.hidden = true; node.inert = true;
    } else if (!active && guarded.has(node)) {
      const old = guarded.get(node);
      if (old.style === null) node.removeAttribute('style'); else node.setAttribute('style', old.style);
      node.hidden = old.hidden; node.inert = old.inert; guarded.delete(node);
    }
  }
  // 仅保护购物车结账入口，绝不触碰产品页 Buy it now / PayPal。
  function paintCheckoutGuard() {
    const relevant = adding || (cart ? cart.items.some(item => isTarget(item) || isGift(item, state)) : cartWasParticipant);
    const locked = relevant && (needsVerification || syncing || busy || adding || externalChanges > 0 || checkingOut);
    const nodes = document.querySelectorAll('#Cart [name="checkout"],#Cart-Drawer [name="checkout"],#Cart a[href*="/checkout"],#Cart-Drawer a[href*="/checkout"],form[action$="/cart"] [name="checkout"]');
    for (const [node, old] of checkoutGuards) {
      if (locked && node.isConnected) continue;
      if ('disabled' in node) node.disabled = old.disabled;
      for (const [name, value] of Object.entries(old.attributes)) {
        if (value === null) node.removeAttribute(name); else node.setAttribute(name, value);
      }
      node.classList.remove('edm-set-checkout-pending'); checkoutGuards.delete(node);
    }
    if (!locked) return;
    for (const node of nodes) {
      if (node.closest('product-form,.shopify-payment-button,shopify-accelerated-checkout')) continue;
      if (!checkoutGuards.has(node)) checkoutGuards.set(node, { disabled: node.disabled,
        attributes: Object.fromEntries(['aria-disabled', 'aria-busy', 'tabindex'].map(name => [name, node.getAttribute(name)])) });
      if ('disabled' in node) node.disabled = true;
      node.setAttribute('aria-disabled', 'true'); node.setAttribute('aria-busy', 'true'); node.setAttribute('tabindex', '-1');
      node.classList.add('edm-set-checkout-pending');
    }
  }
  // 仅装饰当前活动的零价赠品；不改购物车节点顺序、数量、表单或原生支付按钮。
  function paintGiftBadges() {
    if (!cart) return;
    cart.items.forEach((item, index) => {
      if (!isGift(item, state) || item.original_price !== 0 || item.final_price !== 0) return;
      for (const id of [`CartDrawerItem-${index + 1}`, `CartItem-${index + 1}`]) {
        const row = document.getElementById(id);
        const info = row?.querySelector('.cart-product-link')?.parentElement;
        if (!info?.querySelector(':scope > .fg-fixed-quantity')) continue;
        const option = info.querySelector(':scope > .product-cart-item-options');
        if (!option || option.classList.contains('edm-set-gift-badge')) continue;
        const giftLabel = /^(?:Type\s*:\s*)?(Gift)$/i.exec(option.textContent.trim());
        if (!giftLabel) continue;
        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('viewBox', '0 0 24 24');
        icon.setAttribute('aria-hidden', 'true'); icon.setAttribute('focusable', 'false');
        icon.innerHTML = '<path d="M4 11v9h16v-9M3 7h18v4H3zM12 7v13M12 7H8.5A2.5 2.5 0 1 1 11 4.5L12 7Zm0 0h3.5A2.5 2.5 0 1 0 13 4.5L12 7Z"/>';
        const label = document.createElement('span');
        label.textContent = `${text.free} ${giftLabel[1]}`;
        option.replaceChildren(icon, label);
        option.classList.add('edm-set-gift-badge');
        info.classList.add('edm-set-gift-info');
      }
    });
  }
  function paint() {
    paintCheckoutGuard();
    const visibleProduct = entry && state && ['available', 'ended', 'claimed'].includes(state.state);
    const cartRelevant = cart?.items.some(item => isTarget(item) || isGift(item, state));
    const protectCart = !!cartRelevant || (!cart && cartWasParticipant);
    document.body.classList.toggle('edm-set-cart-active', protectCart);
    document.querySelectorAll('.additional-checkout-buttons,.dynamic-checkout__content').forEach(node => guardAccelerated(node, protectCart));
    paintGiftBadges();
    for (const slot of document.querySelectorAll('[data-edm-slot]')) {
      const product = slot.dataset.edmSlot === 'product';
      const show = product ? visibleProduct : cartRelevant && state && ['available', 'ended', 'claimed'].includes(state.state);
      setHidden(slot, !show);
      if (!show) continue;
      if (slot.dataset.state !== state.state) slot.dataset.state = state.state;
      const ended = state.state === 'ended', claimed = state.state === 'claimed';
      const available = state.state === 'available';
      const low = available && state.remaining >= 1 && state.remaining <= 5;
      setHidden(slot.querySelector('[data-edm-remaining]'), !low);
      setHidden(slot.querySelector('[data-edm-first]'), low || !available);
      setText(slot.querySelector('[data-edm-number]'), String(state.remaining || ''));
      setText(slot.querySelector('[data-edm-count-text]'), state.remaining === 1 ? text.last_one : text.last_many.replace('{count}', state.remaining));
      setText(slot.querySelector('[data-edm-heading]'), ended ? text.ended_title : claimed ? text.claimed_title : product ? text.title : text.cart_title);
      setText(slot.querySelector('[data-edm-description]'), ended ? (product ? text.ended_description : text.ended_cart)
        : claimed ? text.claimed_description : product ? text.description : text.cart_description);
      setHidden(slot.querySelector('[data-edm-free]'), !available);
      setHidden(slot.querySelector('[data-edm-foot]'), !available);
      setHidden(slot.querySelector('[data-edm-error]'), !errorMessage);
      setText(slot.querySelector('[data-edm-error]'), errorMessage);
    }
  }
  function schedulePaint() {
    if (paintScheduled) return;
    paintScheduled = true; requestAnimationFrame(() => { paintScheduled = false; paint(); });
  }
  function renderSections(sections) {
    if (!sections) return;
    const parser = new DOMParser();
    for (const section of sectionList()) {
      const html = sections[section.section];
      if (typeof html !== 'string') continue;
      const incoming = parser.parseFromString(html, 'text/html').querySelector(section.selector);
      const rootElement = document.getElementById(section.id);
      const target = rootElement.querySelector(section.selector) || rootElement;
      if (!incoming) continue;
      for (const placeholder of incoming.querySelectorAll('[data-edm-slot]')) {
        const existing = target.querySelector(`[data-edm-slot="${placeholder.dataset.edmSlot}"]`);
        if (existing) placeholder.replaceWith(existing);
      }
      target.replaceChildren(...incoming.childNodes);
    }
    paint();
  }
  function bundle(body) {
    return { ...body, sections: sectionList().map(s => s.section), sections_url: location.pathname };
  }
  async function refreshState() {
    const evidence = cart?.items.find(isTarget);
    ticket = evidence?.properties._edm_ticket || ticket;
    state = await request('apps/loyalty/edm-set-launch/status', {
      ...(entry && key ? { key, productId: config.dataset.productId || PRODUCT, offerId: OFFER } : {}), ...(ticket ? { ticket } : {})
    });
    if (ALL_PRODUCTS && state.offer && state.offer !== OFFER) state = { state: 'hidden', remaining: 0 };
    if (state.ticket) ticket = state.ticket;
    if (ALL_PRODUCTS) {
      try {
        if (state.state === 'available' && state.ticket) {
          const expiresAt = Number(state.ticket.split('.')[0]) + 7 * 24 * 60 * 60 * 1000;
          if (Number.isFinite(expiresAt)) localStorage.setItem(storageKey, JSON.stringify({ offer: OFFER, ticket: state.ticket, expiresAt }));
        } else if (state.state === 'hidden') localStorage.removeItem(storageKey);
      } catch (_) { /* 不依赖客户端存储作为资格校验 */ }
    }
    stateAt = Date.now();
    document.querySelectorAll('[data-edm-bootstrap-error]').forEach(node => node.remove());
    errorMessage = ''; paint();
    return state;
  }
  function loadGiftProduct() {
    if (giftProduct && Date.now() - giftProductAt < 10000) return Promise.resolve(giftProduct);
    if (!giftRequest) giftRequest = request('products/purple-nonwoven-tote-bag-snap-closure.js')
      .then(product => { giftProduct = product; giftProductAt = Date.now(); return product; })
      .finally(() => { giftRequest = null; });
    return giftRequest;
  }
  async function giftAvailable() {
    const product = await loadGiftProduct();
    const variant = product.variants.find(v => String(v.id) === String(state.giftVariantId));
    return !!variant && variant.price === 0 && variant.available === true && variant.options.includes('Gift');
  }
  function giftItem() {
    return { id: state.giftVariantId, quantity: 1, properties: { _gift: 'true', _edm_offer: OFFER, _edm_ticket: ticket } };
  }
  async function reconcile({ allowAdd = true, reuseState = false } = {}) {
    await waitForTheme();
    const version = externalVersion;
    const changed = () => {
      if (version === externalVersion && !externalChanges) return false;
      dirty = true; needsVerification = true; return true;
    };
    const supplied = pendingCart;
    pendingCart = null;
    cart = supplied?.version === version ? supplied.cart : await request('cart.js');
    if (changed()) return cart;
    // 套装已移除：使用主题返回的购物车直接清理赠品，不等待活动服务。
    if (!cart.items.some(isTarget) && cart.items.some(item => isGift(item, state))) {
      const updates = Object.fromEntries(cart.items.filter(item => isGift(item, state)).map(item => [item.key, 0]));
      cart = await request('cart/update.js', bundle({ updates }));
      renderSections(cart.sections);
      needsVerification = version !== externalVersion || externalChanges > 0;
      if (needsVerification) dirty = true;
      if (entry && !state) await refreshState();
      paint(); return cart;
    }
    if (!reuseState || !state || Date.now() - stateAt >= 10000) await refreshState();
    if (changed()) return cart;
    // 仅有效 EDM 入口可续签旧购物车；保留数量及其他属性，避免过期票据导致漏赠。
    if (entry && state.state === 'available' && state.ticket) {
      let stale = cart.items.find(item => isTarget(item) && item.properties._edm_ticket !== state.ticket);
      for (let attempt = 0; stale && attempt < 100; attempt++) {
        if (changed()) return cart;
        cart = await request('cart/change.js', bundle({ id: stale.key, quantity: stale.quantity,
          properties: { ...stale.properties, _edm_ticket: state.ticket } }));
        renderSections(cart.sections);
        stale = cart.items.find(item => isTarget(item) && item.properties._edm_ticket !== state.ticket);
      }
      if (stale) throw new Error('EDM_TICKET_REFRESH_PENDING');
    }
    let plan = cartPlan(cart, state);
    if (Object.keys(plan.updates).length) {
      if (changed()) return cart;
      cart = await request('cart/update.js', bundle({ updates: plan.updates }));
      renderSections(cart.sections);
    }
    if (allowAdd && plan.addGift) {
      if (await giftAvailable()) {
        if (changed()) return cart;
        const result = await request('cart/add.js', bundle({ items: [giftItem()] }));
        cart = await request('cart.js'); renderSections(result.sections);
      } else { errorMessage = text.gift_unavailable; }
    }
    needsVerification = version !== externalVersion || externalChanges > 0;
    if (needsVerification) dirty = true;
    paint();
    return cart;
  }
  function showError(message) {
    errorMessage = message;
    if (!state) state = { state: 'unavailable', remaining: 0 };
    if (state.state === 'unavailable') {
      const holders = [...(entry ? productForms() : []), ...document.querySelectorAll('#Cart-Drawer .side-panel-content, #Cart')];
      for (const holder of holders) {
        let notice = holder.querySelector('[data-edm-bootstrap-error]');
        if (!notice) {
          notice = document.createElement('p'); notice.dataset.edmBootstrapError = 'true';
          notice.className = 'edm-set-error'; notice.setAttribute('role', 'alert'); holder.append(notice);
        }
        setText(notice, message);
      }
    }
    paint();
  }
  function scheduleSync() {
    if (ignoreOwnEvent) return;
    needsVerification = true;
    paintCheckoutGuard();
    if (externalChanges) { dirty = true; return; }
    if (syncing || busy) { dirty = true; return; }
    syncing = true;
    serial(async () => {
      dirty = false; await reconcile();
      while (dirty && !externalChanges) { dirty = false; await reconcile(); }
    }).catch(() => { dirty = false; needsVerification = true; showError(text.unavailable); })
      .finally(() => { syncing = false; paintCheckoutGuard(); });
  }
  async function waitForTheme() {
    const until = Date.now() + 12000;
    while (externalChanges > 0) {
      if (Date.now() > until) throw new Error('CART_CHANGE_PENDING');
      await new Promise(resolve => setTimeout(resolve, 50));
    }
  }
  async function ensureCheckout() {
    for (let attempt = 0; attempt < 3; attempt++) {
      await waitForTheme(); const version = externalVersion;
      await reconcile();
      if (externalChanges || version !== externalVersion) continue;
      if (cartPlan(cart, state).addGift) throw new Error('GIFT_UNAVAILABLE');
      return;
    }
    throw new Error('CART_CHANGED_DURING_CHECKOUT');
  }
  async function addSet(form) {
    if (!form.reportValidity()) { adding = false; paintCheckoutGuard(); return; }
    busy = true; form.classList.add('edm-set-busy'); form.setAttribute('aria-busy', 'true');
    needsVerification = true; paintCheckoutGuard();
    try {
      // 与购物车读取并行预检；短时复用已确认活动状态，结账时仍强制重新验证。
      const preload = state?.state === 'available' ? loadGiftProduct().catch(() => null) : Promise.resolve();
      await reconcile({ allowAdd: false, reuseState: true });
      await preload;
      await waitForTheme();
      if (dirty) { dirty = false; await reconcile({ allowAdd: false }); }
      const preparationVersion = externalVersion;
      const formData = new FormData(form);
      const quantity = Number(formData.get('quantity') || 1);
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100) throw new Error('INVALID_QUANTITY');
      const properties = {};
      for (const [name, value] of formData) {
        const match = /^properties\[(.+)\]$/.exec(name);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      delete properties._gift; delete properties._edm_ticket; delete properties._edm_offer;
      const participating = state.state === 'available';
      if (participating) Object.assign(properties, { _edm_offer: OFFER, _edm_ticket: ticket });
      const variantId = ALL_PRODUCTS ? String(formData.get('id') || '') : VARIANT;
      if (!/^\d+$/.test(variantId) || variantId === String(state.giftVariantId)) throw new Error('INVALID_VARIANT');
      const target = { id: variantId, quantity, properties };
      if (formData.get('selling_plan')) target.selling_plan = formData.get('selling_plan');
      const items = [target];
      const hasGift = cartPlan(cart, state).hasGift;
      if (participating && !hasGift) {
        if (await giftAvailable()) items.push(giftItem());
        else errorMessage = text.gift_unavailable;
      }
      if (externalChanges || preparationVersion !== externalVersion) {
        dirty = true; throw new Error('CART_CHANGED_DURING_ADD');
      }
      const addVersion = externalVersion;
      const result = await request('cart/add.js', bundle({ items }));
      cart = await request('cart.js'); renderSections(result.sections);
      // 免费商品不构成购买；以 Shopify 返回价格复核，清理误带赠品后才解锁结账。
      const postAddPlan = cartPlan(cart, state);
      if (Object.keys(postAddPlan.updates).length) {
        cart = await request('cart/update.js', bundle({ updates: postAddPlan.updates }));
        renderSections(cart.sections);
      }
      ignoreOwnEvent = true;
      try {
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: result.items?.[0] || result } }));
        document.getElementById('cart-drawer-toggle')?.click();
      } finally { ignoreOwnEvent = false; }
      needsVerification = dirty || externalChanges > 0 || addVersion !== externalVersion;
      if (needsVerification) dirty = true;
    } catch (_) {
      // 请求超时可能已落入 Shopify；不自动重试加购，防止重复商品。
      try { cart = await request('cart.js'); } catch (_) { /* 保留上一次已确认的视图 */ }
      needsVerification = true;
      showError(text.add_error);
    } finally {
      busy = false; adding = false; form.classList.remove('edm-set-busy'); form.removeAttribute('aria-busy');
      if (dirty) { dirty = false; scheduleSync(); }
      paintCheckoutGuard();
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    // 仅“加入购物车”参与赠礼；原生 Buy it now / PayPal 不拦截、不附加活动属性。
    if (form.action.includes('/cart/add') && event.submitter?.name !== 'add') return;
    const isSet = entry && form.action.includes('/cart/add') && (ALL_PRODUCTS || String(new FormData(form).get('id')) === VARIANT);
    if (isSet) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!adding) { adding = true; paintCheckoutGuard(); serial(() => addSet(form)); }
    } else if (event.submitter?.name === 'checkout' && (cartWasParticipant || cart?.items.some(item => isTarget(item) || isGift(item, state)))) {
      event.preventDefault(); event.stopImmediatePropagation(); checkout();
    }
  }, true);
  function checkout() {
    if (checkingOut) return;
    checkingOut = true; paintCheckoutGuard();
    serial(() => ensureCheckout()).then(() => location.assign(root + 'checkout'))
      .catch(() => { needsVerification = true; showError(text.unavailable); })
      .finally(() => { checkingOut = false; paintCheckoutGuard(); });
  }
  // 主题 product-card 的统一加购事件，覆盖普通快捷按钮及尺寸选项。
  document.addEventListener('cart:edm-quick-add', event => {
    if (!ALL_PRODUCTS || !entry) return;
    event.preventDefault();
    const { button: quick, variantId } = event.detail || {};
    if (!quick || adding || quick.disabled || quick.getAttribute('aria-disabled') === 'true') return;
    const form = document.createElement('form');
    for (const [name, value] of Object.entries({ id: String(variantId), quantity: '1' })) {
      const input = document.createElement('input'); input.name = name; input.value = value; form.append(input);
    }
    const previousAria = quick.getAttribute('aria-disabled');
    adding = true; quick.classList.add('loading'); quick.setAttribute('aria-disabled', 'true'); paintCheckoutGuard();
    serial(() => addSet(form)).finally(() => {
      quick.classList.remove('loading');
      if (previousAria === null) quick.removeAttribute('aria-disabled'); else quick.setAttribute('aria-disabled', previousAria);
    });
  });
  document.addEventListener('click', event => {
    if (event.target.closest('.edm-set-checkout-pending')) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    const link = event.target.closest('a[href]');
    if (!link || !(cartWasParticipant || cart?.items.some(item => isTarget(item) || isGift(item, state)))) return;
    if (link.closest('product-form,.shopify-payment-button,shopify-accelerated-checkout')) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && /\/checkout\/?$/.test(url.pathname)) {
      event.preventDefault(); event.stopImmediatePropagation(); checkout();
    }
  }, true);
  document.addEventListener('line-item:change:start', () => {
    if (externalChanges) overlappingChanges = true;
    externalChanges++; externalVersion++; pendingCart = null; needsVerification = true; paintCheckoutGuard();
  });
  document.addEventListener('line-item:change:finished', () => {
    externalChanges = Math.max(0, externalChanges - 1);
    if (!externalChanges) {
      if (overlappingChanges) pendingCart = null;
      overlappingChanges = false; scheduleSync();
    }
  });
  document.addEventListener('line-item:change:end', event => {
    if (Array.isArray(event.detail?.cart?.items)) pendingCart = { cart: event.detail.cart, version: externalVersion };
    paintCheckoutGuard();
    if (!externalChanges) scheduleSync();
  });
  document.addEventListener('cart:edm-update-error', () => { needsVerification = true; showError(text.unavailable); });
  ['cart:item-added', 'cart-drawer:open'].forEach(name => document.addEventListener(name, scheduleSync));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) scheduleSync(); });
  window.addEventListener('pageshow', event => { if (event.persisted) scheduleSync(); });
  // 仅监测 section 替换；不在 DOM 变化时请求 API，也不重建活动卡片。
  new MutationObserver(records => {
    paintCheckoutGuard();
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1
      && (node.matches('[data-edm-slot],product-form') || node.querySelector('[data-edm-slot],product-form'))))) schedulePaint();
  }).observe(document.body, { childList: true, subtree: true });
  setInterval(() => {
    if (!document.hidden && (entry || cart?.items.some(item => isTarget(item) || isGift(item, state)))) scheduleSync();
  }, 30000);
  paint();
  scheduleSync();
})();